<div class="modal-header">
    <div class="modal-header__text">
        <h4 class="modal-title" *ngIf="title">{{ title }}</h4>
        <p class="modal-subtitle" *ngIf="subtitle">{{ subtitle }}</p>
    </div>
    <button type="button"
            class="close pull-right"
            aria-label="Close"
            (click)="multiple ? pickedOption('CANCELED') : cancel()">
        <img src="assets/common/ic_x_s_size.svg" alt="Close" width="16" height="16" />
    </button>
</div>

<div class="modal-body">
    <!-- Enhanced format: separate title and message -->
    <div *ngIf="message">
        <p *ngIf="renderAsHtml" [innerHTML]="message"></p>
        <p *ngIf="!renderAsHtml">{{ message }}</p>
    </div>
    <!-- Backward compatibility: title as message (no separate message field) -->
    <div *ngIf="!message">
        <p *ngIf="renderAsHtml" [innerHTML]="title"></p>
        <p *ngIf="!renderAsHtml">{{ title }}</p>
    </div>
</div>

<!-- Enhanced format: custom buttons -->
<div class="modal-footer" *ngIf="buttons && buttons.length > 0">
    <button *ngFor="let button of buttons"
            type="button"
            [class]="getButtonClass(button)"
            (click)="onButtonClick(button)">{{ button.label }}</button>
</div>

<!-- Backward compatibility: default buttons -->
<div class="modal-footer" *ngIf="!buttons && !multiple">
    <button *ngIf="!hideCancel" 
            type="button"
            class="btn btn-default"
            (click)="cancel()">{{ cancelBtnName }}</button>
    <button type="button"
            [class]="getConfirmButtonClass()"
            (click)="confirm()">{{ confirmBtnName }}</button>        
</div>

<!-- Multiple choice format (backward compatibility) -->
<div class="modal-footer modal-footer-multiple" *ngIf="multiple && buttonlist && buttonlist.length">
    <button type="button"
            class="btn btn-default cancel"
            (click)="pickedOption('CANCELED')">{{ cancelBtnName }}</button>
    <button *ngFor="let pick of buttonlist"
            type="button"
            class="btn btn-default"
            (click)="pickedOption(pick.value)">{{ pick.name }}</button>
</div>
